import { useQuery, skipToken } from "@tanstack/react-query";
import { useSlideInMenu } from "../hooks/useSlideInMenu";
import { Flex, Image, Link, Text } from "@chakra-ui/react";
import { TitleWithGearIcon } from "../../../screens/reader/components/menuTitles";
import { useTranslation } from "react-i18next";
import { Release, ServerSingleResponse } from "../../../types";
import { AxiosResponse } from "axios";
import { useUserEntitlementQueryKey } from "../../../hooks/useUserEntitlementQueryKey";

export function ReleaseInfoMenuTitle() {
  const { t } = useTranslation();
  const { releaseUuid, openComicInfoMenu, navigationContext } =
    useSlideInMenu();
  const entitlementQueryKey = useUserEntitlementQueryKey();
  const { data: fetchedRelease } = useQuery<
    AxiosResponse<ServerSingleResponse<Release>>
  >({
    enabled: !!releaseUuid,
    queryKey: ["releaseDetailsRelease", releaseUuid, ...entitlementQueryKey],
    queryFn: skipToken,
    networkMode: "offlineFirst",
    placeholderData: (prev) => prev,
  });

  const comic = fetchedRelease?.data.payload.results?.comic;
  if (!comic) {
    return (
      <TitleWithGearIcon
        title={t("components.slideInMenu.releaseInfoMenu.releaseInfo")}
        label={t("components.slideInMenu.releaseInfoMenu.editRelease")}
        enabled={false}
        editUrl={""}
      />
    );
  }
  return (
    <Flex flexDirection="row" gap="8px" width="100%" alignItems="center">
      <Image
        width="22px"
        height="34px"
        src={comic.image_tiny_url}
        alt={`Comic cover for ${comic.name}`}
        borderRadius="2px"
        border="1px solid"
        borderColor="transparent.white.10"
        marginRight="8px"
      />
      <Flex flexDirection="column" width="100%">
        <Text
          fontSize="18px"
          fontStyle="normal"
          fontWeight="700"
          lineHeight="130%"
        >
          {comic.name}
        </Text>
        <Link
          fontSize="12px"
          fontStyle="normal"
          fontWeight="700"
          lineHeight="150%"
          letterSpacing="0.25px"
          color="blaze.300"
          transition="all .1s linear"
          width="fit-content"
          _hover={{
            color: "blaze.blaze",
          }}
          onClick={() =>
            openComicInfoMenu(comic.slug, {
              ...(navigationContext ?? {}),
              area: "release-details",
            })
          }
        >
          {t("components.slideInMenu.releaseInfoMenu.viewSeriesInfo")}
        </Link>
      </Flex>
    </Flex>
  );
}
